































import Vue from 'vue';
import { uniqueId } from 'lodash';

const PREFIX = 'info-hint-';

export default Vue.extend({
  name: 'InfoHint',
  props: {
    message: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    getUniqueId(): number {
      return uniqueId(PREFIX);
    },
  },
});
